import {
  Divider,
  Grid,
  Paper,
  Table,
  TableBody,
  TableContainer,
  TableHead,
  TableCell,
  TableRow,
} from "@mui/material";
import Typography from "@mui/material/Typography";
import { formatMoney } from "../../helpers/functions";

export default function CustomerStatementItem({ customerCode, customerData }) {
  // Calculates correct sum and period balance by accounting for RC, CN, JE
  const transactions = customerData?.customerTransaction || [];
  const calculatedTotalSum = customerData.totalSum || 0;
  const calculatedPeriodBalance = customerData.periodBalance || 0;

  return (
    <Grid
      container
      spacing={1}
      direction="column"
      sx={{ width: "100%" }}
    > 
      {/* Lists information about the customer */}
      <Paper variant="outlined" elevation={0}>
        {/* Customer Information */}
        <Grid item xs={12} sx={{ padding: 2, borderWidth: 1, borderStyle: "solid", borderColor: "black"}}>
          <Typography variant="body1">Customer Code: {customerCode}</Typography>
          <Typography variant="body1">Customer Name: {customerData.customerName}</Typography>
          <Typography variant="body1">Address: {customerData.shippingAddress}</Typography>
          <Typography variant="body1">Phone Number: {customerData.phone}</Typography>
          <Typography variant="body1">Fax Number: {customerData.fax}</Typography>
          <Typography variant="body1">Terms: {customerData.paymentGroup}</Typography>
          <Typography variant="body1">Credit Limit: {"$" + customerData.creditLimit}</Typography>
          <Typography variant="body1">Sales Rep: {customerData.salesRepName}</Typography>
          <Typography variant="body1">ATTN: {customerData.attn}</Typography>
        </Grid>

        <Divider/>
        {/* Table for the customers invoices */}
        <TableContainer>
          <Table>
            {/* Table Header */}
            <TableHead>
              <TableRow>
                <TableCell>Document Number</TableCell>
                <TableCell>Invoiced Date</TableCell>
                <TableCell>Original Amount</TableCell>
                <TableCell>Open Balance</TableCell>
                <TableCell>Days Open</TableCell>
              </TableRow>
            </TableHead>
            {/* Table body */}
            <TableBody>
	      {customerData.customerTransaction?.map((transaction) => {
		      return (
            <TableRow key={transaction.orderNumber || transaction.id}>
              <TableCell>{transaction.orderNumber}</TableCell>
              <TableCell>{transaction.invoicedDate}</TableCell>
              <TableCell>{transaction.type == "I" ? formatMoney(Math.abs(transaction.total)) : "(" + formatMoney(Math.abs(transaction.total)) + ")"}</TableCell>
              <TableCell>{transaction.type == "I" ? formatMoney(Math.abs(transaction.openBalance)) : formatMoney(transaction.openBalance)}</TableCell>
              <TableCell>{transaction.daysOpen}</TableCell>
            </TableRow>
          );
	      })}

              {/* Display Sum of Original Amount and Period Balance Balance */}
              <TableRow>
                <TableCell/>
                <TableCell sx={{fontWeight: "bold"}}>Total Original Amount:</TableCell>
                <TableCell>{formatMoney(calculatedTotalSum)}</TableCell>
                <TableCell sx={{fontWeight: "bold"}}>Period Balance:</TableCell>
                <TableCell>{formatMoney(calculatedPeriodBalance)}</TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>
      </Paper>
    </Grid>
  );
};
